import React from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Button, useMediaQuery } from '@mui/material';
import logo from '../assets/logo.png';
import glasses from '../assets/glasses.png';

const Header = () => {
  const isMobile = useMediaQuery('(max-width:859px)');
  const isTablet = useMediaQuery('(min-width:860px) and (max-width:1279px)');

  const logoWidth = isMobile ? 128 : isTablet ? 160 : 233;
  const logoHeight = isMobile ? 32 : isTablet ? 40 : 56.65;
  const fontSizeCreator = isMobile ? '16px' : isTablet ? '16px' : '20px';
  const badgeFontSize = isMobile ? '0px' : isTablet ? '14px' : '18px';
  const glassesWidth = isTablet ? 24 : 30;
  const glassesHeight = isTablet ? 14 : 16;

  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      sx={{
        p: isMobile ? '20px 20px 0' : isTablet ? '32px 40px' : '50px 60px',
        maxWidth: '1920px',
        mx: 'auto',
        width: '100%',
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: isMobile ? 3 : 0,
        }}
      >
        {/* Logo */}
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <img
            src={logo}
            alt="Logo"
            width={logoWidth}
            height={logoHeight}
            style={{ cursor: 'pointer' }}
          />
        </Box>

        {/* Center text */}
        {!isMobile && (
          <Typography
            sx={{
              color: '#FFFFFF',
              fontFamily: 'Sora, sans-serif',
              fontWeight: 500,
              fontSize: fontSizeCreator,
              opacity: 0.6,
              whiteSpace: 'nowrap',
            }}
          >
            Created by Artur Sychov and Phil Traut
          </Typography>
        )}

        {/* Button */}
        {!isMobile && (
          <Button
            component="a"
            href="https://apps.apple.com/us/app/auratap/id6754709124"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            size="large"
            sx={{
              height: '53.23px',
              fontFamily: 'Sora, sans-serif',
              backgroundColor: '#30D158',
              color: '#FFFFFF',
              borderRadius: isMobile ? '43.44px' : '50px',
              boxShadow: 'none',
              textTransform: 'none',
              fontWeight: isMobile ? 700 : 600,
              fontStyle: 'normal',
              fontSize: isMobile ? '14.77px' : '17px',
              lineHeight: '100%',
              letterSpacing: '0em',
              px: isMobile ? '26.07px' : '30px',
              py: isMobile ? '19.11px' : '22px',
              transition: 'transform 0.3s ease, background-color 0.3s ease',

              '&:hover': {
                backgroundColor: '#30D158',
                boxShadow: 'none',
                transform: 'scale(1.05)',
              },
            }}
          >
            Get App Now
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;